































import {Component, Vue} from 'vue-property-decorator'
import CompanyApi from "@/module/device/CompanyApi";
import {Container} from "typescript-ioc";
import {CcreateForm} from "@/form/CompanyForm";
import {tagViewModule} from "@/store/module/TagViewModule";
import {RouteName} from "@/router";

@Component({
  components: {},
})
export default class CompanyCreateView extends Vue {

  private companyApi = Container.get(CompanyApi)

  private form = new CcreateForm()

  private async createCompany() {
    await this.companyApi.create(this.form)
    await tagViewModule.delCachedViewByRouteName(RouteName.COMPANY)
    this.finally()
  }

  private cancel() {
    this.finally()
  }

  private async finally() {
    await tagViewModule.delViewByRouteName(RouteName.COMPANY_REGISTER)
    this.$redirector.company()
  }
}
